import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { environment } from '../../environments/environment';

export const MENSAJE_ALTO = 'colmena:restitucion:alto';
export const MENSAJE_SCROLL_ARRIBA = 'colmena:restitucion:scroll-arriba';

/**
 * Publica el alto del documento al padre que embebe este portal, para que el `iframe` crezca
 * con el contenido en lugar de generar un scroll anidado.
 *
 * Hace falta porque el flujo de Pronto Pago es mucho más alto que el resto del portal y su
 * alto cambia al elegir modalidad, paginar las cuotas o expandir el detalle de una deuda.
 *
 * El origen del padre se declara por ambiente y **nunca** es `'*'`: con un comodín, cualquier
 * página que embeba este portal recibiría los mensajes.
 */
@Injectable({ providedIn: 'root' })
export class IframeResizeService implements OnDestroy {

  private observer?: ResizeObserver;
  private ultimoAlto = 0;
  private yaAdvertido = false;

  constructor(private readonly zone: NgZone) { }

  iniciar(): void {
    if (!this.puedePublicar()) {
      return;
    }

    this.zone.runOutsideAngular(() => {
      this.observer = new ResizeObserver(() => this.publicarAlto());
      this.observer.observe(document.body);
    });

    this.publicarAlto();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = undefined;
  }

  solicitarScrollArriba(): void {
    this.enviar({ tipo: MENSAJE_SCROLL_ARRIBA });
  }

  private publicarAlto(): void {
    const alto = Math.ceil(document.documentElement.scrollHeight);
    if (alto === this.ultimoAlto) {
      return;
    }
    this.ultimoAlto = alto;
    this.enviar({ tipo: MENSAJE_ALTO, alto });
  }

  private enviar(mensaje: object): void {
    if (!this.puedePublicar()) {
      return;
    }
    window.parent.postMessage(mensaje, environment.iframe.origenPadre);
  }

  private puedePublicar(): boolean {
    if (!this.estaEmbebido()) {
      return false;
    }
    if (!environment.iframe.origenPadre) {
      this.advertirOrigenSinConfigurar();
      return false;
    }
    return true;
  }

  private estaEmbebido(): boolean {
    return window.parent !== window;
  }

  private advertirOrigenSinConfigurar(): void {
    if (this.yaAdvertido) {
      return;
    }
    this.yaAdvertido = true;
    console.warn(
      'El portal está embebido pero environment.iframe.origenPadre está vacío. ' +
      'No se publicará el alto al contenedor y el iframe no crecerá con el contenido.'
    );
  }
}
